<template>
    <div class="" style="">
        <div class="topImgContent">
            <div class="topImgTitleContent">
                <div class="topImgTitle">通知公告</div>
                <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
                <div class="e-flex menuContent">
                    <img class="ic_home" src="@/assets/images/ic_home.png">
                    <div class="pointer" @click="goMainPage()">首页</div>
                    <div>/</div>
                    <div class="pointer" @click="$router.push({ path: (from && from == 1) ? '/index/index' : '/twoRegionPolicy/twoRegionPolicyAnnouncement', query: {}})">通知公告</div>
                    <div>/</div>
                    <div>正文</div>
                </div>
            </div>
        </div>
        <div class="e-flex trpsd_detailContent">
            <div class="trpsd_detailContentWhite">
                <div class="trpsd_detailTop">
                    <div class="trpsd_detailTitle">{{ info ? info.title : '' }}</div>
                    <div class="trpsd_detailDate">{{ info ? info.publishDate.replace('-','年').replace('-','月') + '日' : '' }}</div>
                </div>
                <div class="trpsd_detailContentText" v-html="info ? info.content : ''"></div>
            </div>
        </div>
        <div class="pd_paginationNewsContent e-flex">
          <div class="pd_paginationWhiteContent">
              <div class="changePageList e-flex" v-if="prev" @click="changeList(prev)">
                <img class="pageCHangeIcon" src="@/assets/images/ic_top.png">
                <div class="changePageLabel">上一篇</div>
                <div class="changePageCommon e-line-1">{{ prev.title }}</div>
              </div>
              <div class="changePageList e-flex" v-if="next" @click="changeList(next)">
                <img class="pageCHangeIcon" src="@/assets/images/ic_down.png">
                <div class="changePageLabel">下一篇</div>
                <div class="changePageCommon e-line-1">{{ next.title }}</div>
              </div>
          </div>
        </div>
    </div>
  </template>
  
  <script>
    import '../../styles/twoRegionPolicy.css'
    export default {
      name: 'twoRegionPolicyAnnouncementDetail',
      data () {
        return {
          from: '',
          id: '',
          info: null,
          prev: null,
          next: null
        }
      },
      created() {
        this.from = this.$route.query.from
        this.id = this.$route.query.id
        this.getDetail()
        this.getLastNext()
      },
      methods: {
        goMainPage() {
          this.$emit('goNavPage', {
            key:'1',
            path: ['1'],
            pathId: '1'
          })
        },
        getDetail() {
          this.request({
              url: 'notice/detail',
              method: 'POST',
              data: {
                id: this.id
              }
          }).then(res => {
              this.info = res.data
          })
        },
        getLastNext() {
          this.request({
              url: 'notice/lastNext',
              method: 'POST',
              data: {
                id: this.id
              }
          }).then(res => {
            res.data.forEach((item, index, array) => {
              if (item.id > this.id) {
                this.prev = item
              } else {
                this.next = item
              }
            })
          })
        },
        changeList(item) {
          this.id = item.id
          this.prev = null
          this.next = null
          this.getDetail()
          this.getLastNext()
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/twoRegionPolicy/twoRegionPolicyAnnouncementDetail.vue